<template>
  <div>
    <Layout
      :stageTitle="$t(`subscription.stage-title.PersonalInfos`)"
      :stageSubTitle="$t('subscription.stage-subtitle.stage-validation')"
      showValidation
      :validation.sync="formValid1"
    >
      <PersonTab1 />
    </Layout>

    <Layout
      :stageTitle="$t(`subscription.stage-title.ContactInfos`)"
      :stageSubTitle="$t('subscription.stage-subtitle.stage-validation')"
      showValidation
      :validation.sync="formValid2"
    >
      <PersonTab2 />
    </Layout>

    <Layout
      footer
      :stageTitle="$t(`subscription.stage-title.BankInfos`)"
      :stageSubTitle="$t('subscription.stage-subtitle.stage-validation')"
      showValidation
      :validation.sync="formValid3"
    >
      <PersonTab3 />
    </Layout>
  </div>
</template>

<script>
  import PersonTab1 from '@/components/RightDrawer/display/PersonTabPerso'
  import PersonTab2 from '@/components/RightDrawer/display/PersonTabContact'
  import PersonTab3 from '@/components/RightDrawer/display/PersonTabBank'
  import Layout from '@/pages/Subscriber/steps-sub/Layout'

  export default {
    components: {
      Layout,
      PersonTab1,
      PersonTab2,
      PersonTab3,
    },
    props: {
      stageTitle: {
        type: String,
        required: true,
      },
      stageSubTitle: {
        type: String,
        required: true,
      },
      formValid: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        formValid1: false,
        formValid2: false,
        formValid3: false,
      }
    },
    computed: {
      internalValid: {
        get() {
          return this.formValid
        },
        set(value) {
          return this.$emit('update:formValid', value)
        },
      },
    },
    watch: {
      $data: {
        handler: function(newValue) {
          this.internalValid = newValue.formValid1 && newValue.formValid2 && newValue.formValid3
        },
        deep: true,
      },
    },
  }
</script>
